import type {
  CreateWhitelabelConfigBody,
  UpdateWhitelabelConfigBody,
} from "@nlc/shared-types";

import { useNavigate } from "@tanstack/react-router";

import { toast } from "@/components/toast/toast-queue";
import { FeaturePageLayout } from "@/features/shared/layout/FeaturePageLayout";

import { WhitelabelForm } from "./components/WhitelabelForm";
import { useCreateWhitelabelConfig } from "./shared/hooks/useCreateWhitelabelConfig";

export function CreateWhitelabelConfigPage() {
  const navigate = useNavigate();
  const { mutate: createConfig } = useCreateWhitelabelConfig();

  const handleSubmit = (
    data: CreateWhitelabelConfigBody | UpdateWhitelabelConfigBody,
  ) => {
    createConfig(data as CreateWhitelabelConfigBody, {
      onError: (error) => {
        console.error("Failed to create whitelabel config", error);
        toast.add(
          {
            description: error.message || "Failed to create whitelabel config.",
            title: "Error",
            type: "error",
          },
          { timeout: 5000 },
        );
      },
      onSuccess: () => {
        toast.add(
          {
            description: "The whitelabel config has been successfully created.",
            title: "Config created",
            type: "success",
          },
          { timeout: 5000 },
        );
        navigate({ to: "/whitelabel" as string });
      },
    });
  };

  return (
    <div className="p-xl">
      <FeaturePageLayout title="Create Whitelabel Config">
        <WhitelabelForm
          onCancel={() => navigate({ to: "/whitelabel" as string })}
          onSubmit={handleSubmit}
        />
      </FeaturePageLayout>
    </div>
  );
}
